import { asyncFlow } from '@helo/utils'

import { ConfigSlice } from '../config/configSlice'
import { AppStatusSlice } from './appStatusSlice'

const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))

const pingApi = async (apiUrl: string): Promise<boolean> => {
  try {
    const response = await fetch(`${apiUrl}/health/heartbeat`)
    return response.ok
  } catch {
    return false
  }
}

const ensureApiAvailable = () =>
  asyncFlow(
    asyncFlow.inputExtends<AppStatusSlice & ConfigSlice>(),
    async store => {
      const { API_URL } = store.config

      if (await pingApi(API_URL)) {
        return {
          ...store,
          appStatus: {
            ...store.appStatus,
            apiStatus: 'available' as const,
          },
        }
      }

      console.warn('API inaccessible, retrying until available')

      let storeWithUnavailable = {
        ...store,
        appStatus: {
          ...store.appStatus,
          apiStatus: 'unavailable' as const,
        },
      }

      while (!(await pingApi(API_URL))) {
        await sleep(1000)
      }

      console.log('API connection reestablished')

      return {
        ...storeWithUnavailable,
        appStatus: {
          ...storeWithUnavailable.appStatus,
          apiStatus: 'available' as const,
        },
      }
    },
  )

export const AppStatusSliceActions = {
  ensureApiAvailable,
}
